import { convertSourceSnapshotsContextToJSON } from "./context";
import { convertSourceSnapshotsCSVToJSON } from "./csv";
import { convertSourceSnapshotsJSONToJSON } from "./json";
import type { ConverterOutput } from "./types";

export async function convertSourceSnapshotsFileToJSON(
  file: File,
  fileType: "json" | "csv" | "context",
): Promise<ConverterOutput> {
  const txt = await file.text();
  if (fileType === "json") return convertSourceSnapshotsJSONToJSON(txt);
  if (fileType === "csv") return convertSourceSnapshotsCSVToJSON(txt);
  if (fileType === "context") return convertSourceSnapshotsContextToJSON(txt);
  throw new Error(`source converter unexpected MIME_TYPE: ${fileType}`);
}
